(() => {
  const header = document.querySelector('[data-ros-header]');
  if (!header) return;

  const drawer = header.querySelector('[data-ros-mobile-menu]');
  const toggles = header.querySelectorAll('[data-ros-menu-toggle]');
  const search = header.querySelector('input[type="search"]');
  let lastDrawerTrigger = null;

  const setDrawer = (open) => {
    if (!drawer) return;
    drawer.hidden = !open;
    document.documentElement.classList.toggle('ros-menu-open', open);
    toggles.forEach((button) => button.setAttribute('aria-expanded', String(open)));
    drawer.setAttribute('aria-hidden', String(!open));
    if (open) {
      lastDrawerTrigger = document.activeElement;
      requestAnimationFrame(() => drawer.querySelector('button, a, input, select')?.focus());
    } else if (lastDrawerTrigger instanceof HTMLElement) {
      lastDrawerTrigger.focus();
    }
  };

  toggles.forEach((button) => {
    button.addEventListener('click', () => setDrawer(drawer?.hidden ?? true));
  });

  header.querySelector('[data-ros-search-focus]')?.addEventListener('click', () => {
    header.classList.add('is-searching');
    search?.focus();
    search?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });

  search?.addEventListener('blur', () => {
    if (!search.value) header.classList.remove('is-searching');
  });

  drawer?.addEventListener('click', (event) => {
    if (event.target === drawer) setDrawer(false);
    if (event.target.closest('a')) setDrawer(false);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') setDrawer(false);
    if (event.key === 'Tab' && drawer && !drawer.hidden) {
      const focusable = [...drawer.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled])')].filter((node) => node.offsetParent !== null);
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    }
  });

  const updateHeader = () => header.classList.toggle('is-scrolled', window.scrollY > 16);
  updateHeader();
  window.addEventListener('scroll', updateHeader, { passive: true });
})();

(() => {
  const initializeCarousels = (scope = document) => {
    scope.querySelectorAll('.ros-home-carousel').forEach((section) => {
      if (section.dataset.carouselReady === 'true') return;
      const track = section.querySelector('[data-product-carousel]');
      const previous = section.querySelector('[data-carousel-previous]');
      const next = section.querySelector('[data-carousel-next]');
      if (!track) return;
      section.dataset.carouselReady = 'true';

      const distance = () => {
        const card = track.querySelector('.ros-product-card');
        const gap = Number.parseFloat(getComputedStyle(track).columnGap || '0');
        return (card?.getBoundingClientRect().width || track.clientWidth * .8) + gap;
      };
      previous?.addEventListener('click', () => track.scrollBy({ left: -distance(), behavior: 'smooth' }));
      next?.addEventListener('click', () => track.scrollBy({ left: distance(), behavior: 'smooth' }));
    });
  };

  document.addEventListener('DOMContentLoaded', () => initializeCarousels());
  document.addEventListener('shopify:section:load', (event) => initializeCarousels(event.target));
})();
